
import {distinctUntilChanged, filter} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// services
import { SessionService } from '@cemex-core/angular-services-v8';
// interfaces
import { ILegalEntity } from '@cemex-core/types-v2';
import { Customer, Company } from './../../cemexcomponents/types/v2/';

@Injectable()
/**
 * @deprecated see core/services/core.service.ts for alternatives
 */
export class LegalEntityDataService {
    private companyKey = 'invpay_company';
    private statusKey = 'invpay_status';
    private _company: Company;
    private _status: string;
    // private legalEntity: ILegalEntity;
    private LegalEntityListener: Observable<ILegalEntity>;

    constructor( private session: SessionService ) {
        this.initialize();
    }

    public getListener(): Observable<ILegalEntity> {
        return this.LegalEntityListener.pipe(filter($ => $ != null),distinctUntilChanged(),);
    }

    public destroySession(): void {
        sessionStorage.removeItem( this.companyKey );
        sessionStorage.removeItem( this.statusKey );
    }

    get company(): Company {
        const aux = sessionStorage.getItem( this.companyKey );
        if ( aux !== undefined && aux !== null ) {
            this._company = JSON.parse( aux );
        } else {
            this._company = undefined;
        }
        return this._company;
    }
    set company( value: Company ) {
        if ( value !== undefined && value !== null ) {
            this._company = value;
            sessionStorage.setItem( this.companyKey, JSON.stringify( this._company ) );
        } else {
            this._company = undefined;
            sessionStorage.removeItem( this.companyKey );
        }
    }

    get status(): string {
        const aux = sessionStorage.getItem( this.statusKey );
        if ( aux !== undefined && aux !== null ) {
            this._status = JSON.parse( aux );
        } else {
            this._status = undefined;
        }
        return this._status;
    }
    set status( value: string ) {
        if ( value !== undefined && value !== null ) {
            this._status = value;
            sessionStorage.setItem( this.statusKey, JSON.stringify( this._status ) );
        } else {
            this._status = undefined;
            sessionStorage.removeItem( this.statusKey );
        }
    }

    private initialize(): void {
        this.LegalEntityListener = this.session.currentLegalEntity;
        if ( !sessionStorage.getItem( this.statusKey ) ) {
            // if null or undefined
            this.status = 'O';
        }
        // if ( !sessionStorage.getItem( this.companyKey ) ) {
        //     // if null or undefined
        //     this.company = {
        //         companyCode: "0",
        //         companyDesc: "All CEMEX subsidiaries",
        //         countryCode: "MX",
        //         divisionCode: 0
        //     };
        // }
    }
}
